import {columnsFn} from './utils';

export const columns = columnsFn({
  company_name: {type: 'string'}
});

export function title(model) {
  return model ? model.company_name : '';
}



// WEBPACK FOOTER //
// ./src/schemas/user_experience.js